import React, { Fragment, Component } from 'react';
import Description from './SelectDescription/SelectDescription';
import Question from './SelectQuestions/SelectQuestion/SelectQuestion';

import axios from '../../axios-orders'

import Label from './SelectQuestions/SelectQuestion/Label/Label';
import { RadioGroup } from '@material-ui/core';
import ReactHtmlParser from 'react-html-parser';

const DEFAULT_VALUE = "0";

export class Select extends Component {
    getAnswerState = () => {
        return this.state.questionsData.map(data => data.req)
    }

    state = {
        current: null,
        content: null,
        questionsData: null,
        questionsTotal: null
    }

    getQuestionsData = () => {
        axios.get("/questions/selects.json")
            .then((res) => {


                console.log("setData")
                this.setState({
                    questionsData: [...res.data],
                    current: this.getQuery()
                })
            })
            .catch((err) => {
                console.log(err)
            }
            )
    }

    getQuery = () => {
        const query = new URLSearchParams(this.props.location.search);
        return +query.get('q')
    }

    getContentByQuery = () => {
        debugger

        let content = null;
        const query = this.getQuery()

        if (query === 0) { // description
            content = (
            <Description buttonClick={
                () => {
                    this.nextPage(query + 1)
                }
            } />
            )
        } else { //other questions
            const id_selects = query;
            const question = { ...this.state.questionsData[id_selects - 1] };
            const id_all = question.id
            let options = question.options.map((option, i) => {
                return (<Label
                    value={`${i}`}
                    key={id_selects + `-` + i}
                    label={
                        ReactHtmlParser(option[0])
                    }

                />)
            })
            // debugger
            content = (
                <Question
                    id={id_selects}
                    optionChange={this.answerChange}
                    buttonClick={this.nextPage}
                    // sync question answer
                    img={question.imgs ? question.imgs[0] : null}
                    options={
                        <RadioGroup
                            onChange={this.answerChange}
                            value={`${this.props.answers[id_all - 1]}`}>
                            {options}
                        </RadioGroup>
                    }
                >
                    {question.ques}
                </Question>
            )
        }

        return content

    }


    componentDidMount() {
        if (!this.state.questionsData) {
           this.getQuestionsData()
        }
    }

    componentDidUpdate(prevProps, prevState) {
        debugger

        // click options ||  setQuestions Data
        if (prevProps.answers !== this.props.answers || prevState.questionsData !== this.state.questionsData) {
            this.setState({
                content: this.getContentByQuery()
            })
        }


        // nextPage
        if (this.state.current !== this.getQuery()) {
            this.setState({
                current: this.getQuery(),
                content: this.getContentByQuery()

            }) 

        }

        // setQuestions Data



    }



    nextPage = () => {
        debugger
        const selectsScore = this.state.questionsData.reduce((acc, data) => {   
            const answer = this.props.answers[+data.id - 1]
            acc += (data.options[+answer][1] === 'true' ? 5 : 0)
            return acc
        }, 0)
        this.props.updateScore(selectsScore, "select")

        // push to nextPage
        const current = this.state.current;
        if (current >= this.state.questionsData.length && current !== 0) {
            this.props.history.push({
                pathname: "/final",
                search: ''
            })
        } else {

            this.props.history.push({
                search: `?q=${current + 1}`
            })
        }

    }






    answerChange = (event, value) => {
        debugger

        // updateRootAnswer
        const id_all = this.state.questionsData[+this.state.current - 1].id
        const prevRootAnswers = [...this.props.answers];
        prevRootAnswers[id_all - 1] = value;

        console.log(value)
        this.props.updateAns(prevRootAnswers)
    }





    render() {
        return (
            <Fragment>
                {this.state.content}
            </Fragment>
        )
    }
}
export default Select


